import React, { Component } from 'react'
import moment from 'moment-timezone'
import { data } from 'jquery'
import TextField from './../component/TextField'


export default class UserActivitiesModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    
    handleBlur = () => {
        if (this.props.validator.allValid()) {
          this.props.validator.hideMessages();
        } else {
          this.props.validator.showMessages();
        }
    };

    render() {
        const { submitEmail, validator, email, handleChangeEmail } = this.props
        return (
            <div className="user_popup active">
            <span className="popup_overlay" onClick={this.props.CloseModal}></span>
            <div className="sundance_popup_createuser box_shadow bg_white">
                <span className="closePopup pointer" onClick={this.props.CloseModal}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.899 0L5.656 4.242L1.414 0L0 1.414L4.242 5.656L0 9.898L1.414 11.312L5.656 7.07L9.899 11.312L11.313 9.898L7.071 5.656L11.313 1.414L9.899 0Z" fill="black" /> </svg>
                </span>
                <div className="bg_white">
                    <div className="sundance_popup_createuser_top">
                        <div className="selection_pass text_center">
                            <label className="pass_label mb_10">Enter Email</label>
                        </div>
                        <form >
                            <div className="field_row pb_10">
                                <TextField autoFocus={true} type="text" placeholder="Email" name="email" value={email} onChange={(e) => handleChangeEmail(e)} onBlur={this.handleBlur} maxLength={255} />
                                <span style={{ color: 'red' }}>{validator.message('email', email, 'required|email|max:255')}</span>
                            </div>
                            <div className="field_row text_center">
                                <button className="uppercase active" onClick={(e) => submitEmail(e)}>Send Mail </button>
                                {/* <button className="uppercase active" onClick={this.submit}>Send Mail </button> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}